<app-sidebar [isOpen]="open" (close)="cancel()" [bigSize]="true">
  @if (open) {
    <div class="account-plan-change astral-sidebar-shell">
      <div class="astral-sidebar-content astral-stack-l">
        <header class="account-plan-change__header">
          <p class="account-plan-change__eyebrow">{{ 'ACCOUNT_PLAN.ACCOUNT_PLAN' | translate }}</p>
          <h2>{{ 'COMPANY.ACCOUNT_PLAN.CHANGE_TITLE' | translate }}</h2>
          <p>{{ 'COMPANY.ACCOUNT_PLAN.CHANGE_INTRO' | translate }}</p>
        </header>

        @if (loading) {
          <div class="account-plan-change__state">{{ 'COMMON.LOADING_MSG' | translate }}</div>
        } @else if (loadFailed) {
          <div class="account-plan-change__state account-plan-change__state--error">
            {{ 'COMPANY.ACCOUNT_PLAN.LOAD_FAILED' | translate }}
          </div>
        } @else if (form) {
          <section class="astral-section-surface astral-form-stack astral-form-stack--relaxed" [formGroup]="form">
            <astral-input [label]="'COMPANY.ACCOUNT_PLAN.CURRENT' | translate" [value]="currentAccountPlanName" [readonly]="true"></astral-input>
            <astral-select [control]="form.controls['accountPlanId']" [itemsSource]="accountPlanSelection"></astral-select>
          </section>

          @if (selectedAccountPlan) {
            <section class="account-plan-change__mappings astral-stack-m">
              <div class="account-plan-change__section-heading">
                <h3>{{ 'COMPANY.ACCOUNT_PLAN.BANK_ACCOUNT_MAPPING' | translate }}</h3>
                <p>{{ 'COMPANY.ACCOUNT_PLAN.BANK_ACCOUNT_MAPPING_INTRO' | translate }}</p>
              </div>

              @if (mappingRows.length === 0) {
                <p class="account-plan-change__empty">{{ 'COMPANY.ACCOUNT_PLAN.NO_BANK_ACCOUNTS' | translate }}</p>
              } @else {
                @for (row of mappingRows; track row.bankAccount.id) {
                  <article class="account-plan-change__mapping astral-section-surface astral-section-surface--nested" [formGroup]="row.form">
                    <div class="account-plan-change__bank-account">
                      <strong>{{ row.bankAccount.name }}</strong>
                      <span>{{ row.bankAccount.clearingNumber }}-{{ row.bankAccount.accountNumber }}</span>
                    </div>
                    <div class="account-plan-change__old-account">
                      <span>{{ 'COMPANY.ACCOUNT_PLAN.OLD_ACCOUNT' | translate }}</span>
                      <strong>
                        {{ row.bankAccount.accountingAccountNumber }} {{ row.bankAccount.accountingAccountName }}
                      </strong>
                    </div>
                    <app-autocomplete [control]="row.form.controls['account']" [itemsSource]="accountSelection"></app-autocomplete>
                  </article>
                }
              }
            </section>
          }
        }
      </div>

      <footer class="astral-sidebar-footer">
        <astral-button
          variant="primary"
          type="button"
          labelKey="SAVE_BTN"
          [disabled]="loading || loadFailed || saving || !selectedAccountPlan"
          (click)="save()"
        ></astral-button>
        <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" [disabled]="saving" (click)="cancel()"></astral-button>
      </footer>
    </div>
  }
</app-sidebar>
